export default __webpack_public_path__ + "static/media/04-RoyalDonut.34a7c81a.png";